import { useContext, useEffect, useId, useRef, useState } from "react";
import Button from "../../Button";
import { VerificationFormContext } from "..";
import { useFormContext } from "react-hook-form";
import { useTypeOnce } from "../../../hooks/useTypeOnce";
import InfiniteSpinnerSvg from "../../Svgs/infinite-spinner";
import InsuranceDisclaimer from "../Disclaimers/InsuranceDisclaimer";

const StepCard = ({
  step = 0,
  response = "",
  title = "",
  imageUrl = "",
  copy = "",
  children,
  hasAnimated = false,
}) => {
  const {
    updateState,
    state: { activeStep, showManualProviderEntryField, isSubmitting },
  } = useContext(VerificationFormContext);

  const form = useFormContext();

  const [typingDone, setTypingDone] = useState(false);

  const responseRef = useTypeOnce(response, 25, step, hasAnimated, () => {
    setTypingDone(true);
  });
  const stepRef = useRef(null);

  const showBackButton =
    step === 1 && showManualProviderEntryField ? false : true;

  const handleNextStep = async () => {
    updateState({ activeStep: step + 1 });
  };

  return (
    <div
      ref={stepRef}
      className={`cvf__step ${step === activeStep ? "cvf__step--active" : ""}`}
      data-step={step}
    >
      <div className="cvf__response--container">
        {response && <div ref={responseRef} className="cvf__response"></div>}
      </div>
      {!isSubmitting ? (
        <section
          className={`cvf__lower-content ${
            step === 1 || typingDone ? "show" : ""
          } `}
        >
          <div className="cvf__step--header">
            <div>
              {title && (
                <div
                  className="cvf__title"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              )}
              {copy && (
                <div
                  className="cvf__copy"
                  dangerouslySetInnerHTML={{ __html: copy }}
                />
              )}
            </div>
            {imageUrl && (
              <div>
                <img src={imageUrl} width="200px" height="auto" />
              </div>
            )}
          </div>
          <div className="cvf__inputs">{children}</div>
          {step === 1 || (step === 2 && <InsuranceDisclaimer />)}
          <div className="cvf__button_container">
            {activeStep === 1 && !showManualProviderEntryField ? (
              <div>
                <div
                  onClick={() =>
                    updateState({ showManualProviderEntryField: true })
                  }
                  className="cvf__navigation-link"
                >
                  My Provider Isn't Listed
                </div>
              </div>
            ) : (
              <>
                {showBackButton && (
                  <div
                    onClick={() => updateState({ activeStep: step - 1 })}
                    className="cvf__navigation-link"
                  >
                    Go Back
                  </div>
                )}
              </>
            )}
            {step === 6 ? (
              <Button
                rank="primary"
                type="submit"
                disabled={!form.formState.isValid}
              >
                Submit Inquiry
              </Button>
            ) : (
              <Button
                rank="primary"
                onClick={handleNextStep}
                chevron
                disabled={!form.formState.isValid}
              >
                Next
              </Button>
            )}
          </div>
        </section>
      ) : (
        <div className="cvf__loading">
          <div className="cvf__title" style={{ textAlign: "center" }}>
            Running insurance verification...
          </div>
          <div className="cvf__spinner-container">
            <InfiniteSpinnerSvg width="18" height="19" />
          </div>
        </div>
      )}
    </div>
  );
};
export default StepCard;
